<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-form-model ref="ruleForm" :model="form" :label-col="labelCol" :rules="rules" v-bind="layout" class="formBox">

          <a-form-model-item
                    label="文件"
                    :help="formErr.file_path"
            >
              <a-upload
                  :max-count="1"
                  :action="this.$store.state.urlChang"
                  :data="{type:5}"
                  :file-list="fileList"
                  :headers="headers"
                  :before-upload="beforeUpload"
                  @change="(file)=>{handleChange(file)}"
                  name="file"
                  :remove="handleRemove"
              >
                <a-button  icon="upload" >上传</a-button>
              </a-upload>
            </a-form-model-item>

          <a-form-model-item
              ref="name"
              label="文件标题"
              prop="name"
              :help="formErr.name"
              :validateStatus='!formErr.name||formErr.name==""?"":"error"'
              style="position: relative"
          >
            <a-input
                :maxLength=100
                v-model="form.name"
                @change="(e) => { formErr.name=''}"
                @blur="(e) => {  form.name = e.target.value.trim() }"
            />
          </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    export default {
        name: "newForm",
        props: ["visible","title","editId"],
        data() {
            return {
              headers: {Authorization: window.sessionStorage.getItem("signature")},
              fileList:[],
              labelCol: { span:5 },
              formList:null,
                drawerConfig ,
                form: {
                  name:"", file_path:""
                },
                formErr: {
                  name:"", file_path:""
                },
              ruleForm: {
                  file_path:[{required: true, message: "请上传文件",}, {
                    whitespace: true,
                    message: "请上传文件 ", trigger: "blur"
                  } ],
                  name:[{required: true, message: "请输入文件名称",}, {
                    whitespace: true,
                    message: "请输入文件名称 ", trigger: "blur"
                  }, {
                    validator: (rule, value, callback) => {
                      validator(rule, value, callback, this.formErr.times)
                    }, trigger: "blur"
                  }]
                       },
                layout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 10 },
                },
            };
        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.administrator. EDIT_DATA({id: a}).then(res => {
                        let val = res.data.data.info
                        this.form = val
                      this.fileList = [
                        {uid: this.form.file_path,
                          name: this.form.name,
                          status: "done",
                          url: this.form.file_path ? this.form.file_path : ""
                        }
                      ]
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
      mounted() {
        this.getFormList()
      },
      methods: {
          getFormList(){
            API.administrator.GET_FORM_LIST().then(res => {
              this.formList = res.data.data.inquiry_field
            })
          },
            onClose() {
                this.$emit("changVisible", false);
                this.formErr={
                  name:"", file_path:""
                }

              this.fileList = []
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.administrator.SUBMIT_ADD : url = API.administrator.SUBMIT_EDIT
                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                              console.log("resres",res)
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })

                              console.log("resresthis.formErr",this.formErr)
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },

        handleChange(info ) {
          let {fileList} = info;
          const status = info.file.status;
          let _that=this
          this.fileList=[]
          if (status !== 'uploading') {
            this.fileList=[]
          }
          if (status === 'done') {
            this.formErr.thumb=""
            this.fileList= fileList
          } else if (status === 'error') {
          }
          if (status === 'uploading') {
            this.fileList= fileList
          }
          if (status=== 'done') {
            _that.formErr.thumb=""
            this.fileList= [fileList[fileList.length-1]]
            console.log("aaafileListfileList",fileList )
          if(fileList[fileList.length-1].response.code==200)  {
            _that.form.name=fileList[fileList.length-1].name
            _that.form.file_path=fileList[fileList.length-1].response.data.url
            _that.formErr= { name:"", file_path:"" }
            console.log("fileListfileList",fileList[fileList.length-1].name)
          }

          }
          //重新设置state
          // this.setState( {fileList});
        },
        handleRemove(){this.fileList=[],this.form.name="",this.form.file_path=""},
        beforeUpload(file) {this.fileList=[]
          // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
          // if (!isJpgOrPng) {
          //   this.$message.error('只能上传jpeg，jpg，png类型图片!');
          //   return false
          // }
          // const isLt2M = file.size / 1024 / 1024 < 2;
          // if (!isLt2M) {
          //   this.$message.error('图片必须小于 2MB!');
          //   return false
          // }
          return new Promise(function (resolve,reject) {
            resolve(file)
          })
        },
        async handlePreview(file) {
          if (!file.url && !file.preview) {
            file.preview = file.originFileObj;
          }
          this.previewImage = file.url || file.preview;
          this.previewVisible = true;
        },
        },
    }
</script>

<style scoped>

.formBox>>>.ant-form-item label{margin-right: 12px!important;}
</style>
